// Example of usage:
// any of element with data-background-changer="true" will change background color of the container
// when it will be in the center of the screen
//
// <div data-background-changer="true">...</div>
//
// to set up colors or change selectors see the Constants section


// --- Constants ---

const DISTANCE_START_CHANGING_COLOR_PX = 900;
const DISTANCE_FINISH_CHANGING_COLOR_PX = 150;
const DESTINATION_COLOR_HEX = "#FFFFFF";
const CONTAINER_SELECTOR = "body";
const ANCOR_SELECTOR = '[data-background-changer="true"]';
const ANCOR_CUSTOM_DESTINATION_COLOR_HEX_ATTR = 'data-background-changer-destination-color-hex';
const ANCOR_CUSTOM_DISTANCE_START_CHANGING_COLOR_PX = 'data-background-changer-distance-start-changing-color-px';
const ANCOR_CUSTOM_DISTANCE_FINISH_CHANGING_COLOR_PX = 'data-background-changer-distance-finish-changing-color-px';

const $container = $(CONTAINER_SELECTOR);
const $elements = $(ANCOR_SELECTOR);
const defaultContainerColor = $container.css("background-color");
const rgbContainerBackground = rgbStringToArray(defaultContainerColor);
const rgbDestinationBackground = hexToRgb(DESTINATION_COLOR_HEX);

const initializeBackgroundColorChanging = () => {
  // check if there are any anchor elements on the page
  const anchorElementsCentersY = getAnchorElementsCenters();

  // and run the handler if there are
  anchorElementsCentersY && setUpSrollHandler();
};

initializeBackgroundColorChanging();

// --- Dom manipulating heplers ---

function getAnchorElementsCenters() {
  if (!$elements.length) {
    return;
  }

  return $elements
    .map((_, el) => $(el).offset().top + $(el).outerHeight() / 2)
    .get();
}

const changeBackgroundColor = (elementsCentersY) => {
  const distance = getDistanceToClosestElementCenter(elementsCentersY);
  const FINAL_DISTANCE_START_CHANGING_COLOR_PX = $elements.attr(ANCOR_CUSTOM_DISTANCE_START_CHANGING_COLOR_PX) ? $elements.attr(ANCOR_CUSTOM_DISTANCE_START_CHANGING_COLOR_PX) : DISTANCE_START_CHANGING_COLOR_PX;

  if (distance > FINAL_DISTANCE_START_CHANGING_COLOR_PX) {
    $container.css("background-color", defaultContainerColor);
    return;
  }

    const FINAL_DISTANCE_FINISH_CHANGING_COLOR_PX = $elements.attr(ANCOR_CUSTOM_DISTANCE_FINISH_CHANGING_COLOR_PX) ? $elements.attr(ANCOR_CUSTOM_DISTANCE_FINISH_CHANGING_COLOR_PX) : DISTANCE_START_CHANGING_COLOR_PX;

  if (distance < FINAL_DISTANCE_FINISH_CHANGING_COLOR_PX) {
    const FINAL_DESTINATION_COLOR_HEX = $elements.attr(ANCOR_CUSTOM_DESTINATION_COLOR_HEX_ATTR) ? $elements.attr(ANCOR_CUSTOM_DESTINATION_COLOR_HEX_ATTR) : DESTINATION_COLOR_HEX;
    $container.css("background-color", FINAL_DESTINATION_COLOR_HEX);
    return;
  }

  const distanceFromCurrnetCoordinateToEndOfColorChangingZone = distance - FINAL_DISTANCE_FINISH_CHANGING_COLOR_PX;
  const changingColorDistance = FINAL_DISTANCE_START_CHANGING_COLOR_PX - FINAL_DISTANCE_FINISH_CHANGING_COLOR_PX;

  const colorChangingPercent = Math.round(distanceFromCurrnetCoordinateToEndOfColorChangingZone  / (changingColorDistance / 100));
  const bg = getNewBackgroundColor(colorChangingPercent);
  $container.css("background-color", bg);
};

// --- Setting up event handlers ---

function setUpSrollHandler() {
  let ticking = false;
  document.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        // recalculating the position of the anchor elements
        // on each scroll event, because they positions can change by other scripts
        const elementsCentersY = getAnchorElementsCenters();

        changeBackgroundColor(elementsCentersY);
        ticking = false;
      });
      ticking = true;
    }
  });
}


// --- Distance and position calculation heplers ---

function getNewBackgroundColor(percent) {
  const finalRgbDestinationBackground = $elements.attr(ANCOR_CUSTOM_DESTINATION_COLOR_HEX_ATTR) ? hexToRgb($elements.attr(ANCOR_CUSTOM_DESTINATION_COLOR_HEX_ATTR)) : rgbDestinationBackground;
  const bgAsArray = interpolateColor(
    finalRgbDestinationBackground,
    rgbContainerBackground,
    percent,
  );
  return `rgb(${bgAsArray.join(",")})`;
}

function getDistanceToClosestElementCenter(elementsCentersY) {
  const screenCenterY = window.scrollY + window.innerHeight / 2;
  return Math.min(
    ...elementsCentersY.map((centerY) => Math.abs(screenCenterY - centerY)),
  );
}


// --- Color conversation helpers ---

function rgbStringToArray(rgbString) {
  return rgbString
    .slice(4, -1)
    .split(",")
    .map((num) => parseInt(num.trim()));
}

function hexToRgb(hex) {
  return hex
    .slice(1)
    .match(/.{2}/g)
    .map((x) => parseInt(x, 16));
}

function interpolateColor(color1, color2, percent) {
  return color1.map((channel, index) => {
    const diff = Math.abs(channel - color2[index]);
    const change = Math.round((diff * percent) / 100);
    return channel > color2[index] ? channel - change : channel + change;
  });
}
